function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Input, Form, Button, Select, Alert, Radio, List, Upload, InputNumber, QRCode, Modal, Typography, Switch, Descriptions, message, DatePicker, Divider, Space, Drawer } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { ExclamationCircleFill, Upload as UploadIc, XCircleFill, CheckCircleFill, Plus, CashStack } from 'react-bootstrap-icons';
import Receipt from "../Receipt";
import Moment from 'react-moment';
import AddPrescriber from "./AddPrescriber";
import AddBusinessProvider from "./AddBusinessProvider";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import OrderReceipt from "../OrderReceip";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Option = Select.Option;
var AddPatientItem = function AddPatientItem(_ref) {
  var _ref$handleUpdate = _ref.handleUpdate,
    handleUpdate = _ref$handleUpdate === void 0 ? null : _ref$handleUpdate,
    patient = _ref.patient;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var ref = useRef();
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showReceipt = _useState4[0],
    setShowReceipt = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    successMessage = _useState8[0],
    setSuccessMessage = _useState8[1];
  var _useState9 = useState([{
      label: "Aucune",
      value: 0
    }]),
    _useState0 = _slicedToArray(_useState9, 2),
    companyOptions = _useState0[0],
    setCompanyOptions = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    companies = _useState10[0],
    setCompanies = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    deptOptions = _useState12[0],
    setDeptOptions = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    serviceOptions = _useState14[0],
    setServiceOptions = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    deptDisabled = _useState16[0],
    setDeptDisabled = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    serviceDisabled = _useState18[0],
    setServiceDisabled = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    serviceTree = _useState20[0],
    setServiceTree = _useState20[1];
  var _useState21 = useState(true),
    _useState22 = _slicedToArray(_useState21, 2),
    insDisabled = _useState22[0],
    setInsDisabled = _useState22[1];
  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    isPdaActive = _useState24[0],
    setIsPdaActive = _useState24[1];
  var _useState25 = useState(0),
    _useState26 = _slicedToArray(_useState25, 2),
    receipAmount = _useState26[0],
    setReceipAmount = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    userCompany = _useState28[0],
    setUserCompany = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    file = _useState30[0],
    setFile = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    rdata = _useState32[0],
    setRdata = _useState32[1];
  var _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    currentCompany = _useState34[0],
    setCurrentCompany = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    discounts = _useState36[0],
    setDiscounts = _useState36[1];
  var _useState37 = useState(0),
    _useState38 = _slicedToArray(_useState37, 2),
    discount = _useState38[0],
    setDiscount = _useState38[1];
  var _useState39 = useState([{
      value: 0,
      label: "Direct"
    }]),
    _useState40 = _slicedToArray(_useState39, 2),
    bpOptions = _useState40[0],
    setBpOtions = _useState40[1];
  var _useState41 = useState(null),
    _useState42 = _slicedToArray(_useState41, 2),
    createdBill = _useState42[0],
    setCreatedBill = _useState42[1];
  var _useState43 = useState([{
      value: 0,
      label: "Non defini"
    }]),
    _useState44 = _slicedToArray(_useState43, 2),
    prescribers = _useState44[0],
    setPrescribers = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    dataChangedPr = _useState46[0],
    setDataChangedPr = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    dataChangedBp = _useState48[0],
    setDataChangedBp = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    showAddPrescriber = _useState50[0],
    setShowAddPrescriber = _useState50[1];
  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    showAddBusinessProvider = _useState52[0],
    setShowAddBusinessProvider = _useState52[1];
  var _useState53 = useState(false),
    _useState54 = _slicedToArray(_useState53, 2),
    pdaFieldDisabled = _useState54[0],
    setPdaFieldDisabled = _useState54[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var onDeptChanged = function onDeptChanged(e) {
    setServiceOptions([]);
    var optArray = e.toString().split(",");
    optArray.forEach(function (o) {
      var ar = serviceTree.filter(function (services) {
        return services.id == o;
      });
      if (ar.length > 0) {
        ar.forEach(function (d) {
          if (d.business_account_medical_items.length > 0) {
            d.business_account_medical_items.forEach(function (e) {
              setServiceOptions(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  label: e.label,
                  value: e.id
                }]);
              });
            });
            form.setFieldsValue({
              service_id: serviceOptions
            });
            setServiceDisabled(false);
          }
        });
      }
    });
  };
  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
    if (v == 0) setInsDisabled(true);else {
      setInsDisabled(false);
      setPdaFieldDisabled(true);
    }
  };
  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'executepatientorder', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setCreatedBill(response.data.bill);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        setShowReceipt(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  var handlePdaChange = function handlePdaChange(checked) {
    setIsPdaActive(checked == true ? 1 : 0);
  };
  var onFinish = function onFinish(values) {
    setRdata([]);
    var formData = new FormData();
    formData.append('mobile', values.mobile);
    formData.append('insnumber', values.insnumber);
    formData.append('prescriber_id', values.prescriber_id);
    formData.append('company_id', values.company_id);
    formData.append('department_id', values.department_id);
    formData.append('ordered_items', values.item_id);
    formData.append("uid", Common.currentUser.id);
    formData.append("pid", patient.id.toString());
    formData.append("is_pda_active", isPdaActive);
    formData.append("discount", values.discount);
    formData.append("paid_amount", values.paid_amount);
    formData.append("business_provider_id", values.business_provider_id);
    var ta = 0;
    setDiscount(values.discount);
    values.item_id.toString().split(",").forEach(function (o) {
      serviceTree.forEach(function (d) {
        d.business_account_medical_items.forEach(function (e) {
          if (e.id == o) {
            //IF CASH PATIENT THE USE BASE PRICE  
            if (values.company_id == 0) {
              ta += eval(e.base_price);
              setRdata(function (prev) {
                return [].concat(_toConsumableArray(prev), [e.label + " " + e.base_price.toLocaleString('fr') + " GNF"]);
              });
            } else {
              //HANDLING COMPANY PRICE CATEGORIES 
              var comp = companies.filter(function (c) {
                return c.id == values.company_id;
              })[0];
              if (comp.company_id == null) {
                ta += eval(e.ent_price * (1 + comp.commercial_rate / 100));
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [e.label + "  " + (e.ent_price * (1 + comp.commercial_rate / 100)).toLocaleString('fr') + " GNF"]);
                });
              }
              if (comp.company_id != null && comp.company.type == 1) {
                ta += eval(e.ins_price * (1 + comp.company.commercial_rate / 100));
                setRdata(function (prev) {
                  return [].concat(_toConsumableArray(prev), [e.label + " " + (e.ins_price * (1 + comp.company.commercial_rate / 100)).toLocaleString('fr') + " GNF"]);
                });
              }
            }
          }
        });
      });
    });
    ta -= values.discount / 100 * ta;
    formData.append('amount', ta);
    if (values.company_id != 0) {
      if (companies.filter(function (c) {
        return c.id == values.company_id;
      }).length > 0) {
        var company_rate = companies.filter(function (c) {
          return c.id == values.company_id;
        })[0].rate;
        setCurrentCompany(companies.filter(function (c) {
          return c.id == values.company_id;
        })[0]);
        formData.append('company_part', ta * company_rate * 0.01);
        formData.append('patient_part', ta * (100 - company_rate) * 0.01);
        setReceipAmount(ta * (100 - company_rate) * 0.01);
      }
    } else {
      formData.append("patient_part", ta);
      formData.append("company_part", 0);
      setReceipAmount(ta);
    }
    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsx(Receipt, {
        company: userCompany,
        discount: values.discount,
        is_pda_active: isPdaActive,
        options: values.item_id,
        serviceTree: serviceTree
      }),
      onOk: function onOk() {
        execOrder(formData);
      }
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      company_id: 0
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 0,
        label: "0%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 1,
        label: "1%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 2,
        label: "2%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 3,
        label: "3%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 4,
        label: "4%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 5,
        label: "5%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 10,
        label: "10%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 15,
        label: "15%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 20,
        label: "20%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 25,
        label: "25%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 30,
        label: "30%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 35,
        label: "35%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 40,
        label: "40%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 45,
        label: "45%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 50,
        label: "50%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 55,
        label: "55%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 60,
        label: "60%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 65,
        label: "65%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 70,
        label: "70%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 75,
        label: "75%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 80,
        label: "80%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 85,
        label: "85%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 90,
        label: "90%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 95,
        label: "95%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 100,
        label: "100%"
      }]);
    });
    form.setFieldsValue({
      discount: 0
    });
    var cr = axios.get(Common.baseApiUrl + "getcompanylist/" + Common.currentUser.id);
    var st = axios.get(Common.baseApiUrl + "getservicetree/" + Common.currentUser.id);
    var bp = axios.get(Common.baseApiUrl + "getbusinessproviders/" + Common.currentUser.id);
    axios.all([cr, st, bp]).then(function (response) {
      var crResponse = response[0];
      var stResponse = response[1];
      var bpResponse = response[2];
      if (crResponse.data.status == 200) {
        setCompanyOptions([{
          label: "Aucune",
          value: 0
        }]);
        setCompanies(crResponse.data.companyList);
        crResponse.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
      }
      if (stResponse.data.status == 200) {
        setServiceTree(stResponse.data.services);
        stResponse.data.services.forEach(function (d) {
          if (d.dcode != 'ADM' && d.dcode != "REC") setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: d.id,
              label: d.label
            }]);
          });
        });
        if (bpResponse.data.status == 200) {
          setBpOtions([{
            value: 0,
            label: "Direct"
          }]);
          bpResponse.data.providers.forEach(function (p) {
            setBpOtions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                value: p.id,
                label: p.name + " (" + p.origin + ")"
              }]);
            });
          });
        }
        form.setFieldsValue({
          gender: 'F',
          category: 0,
          insnumber: null,
          business_provider_id: 0
        });
      }
    })["catch"](function (error) {});
  }, [dataChangedBp]);
  useEffect(function () {
    form.setFieldsValue({
      prescriber_id: 0,
      business_provider_id: 0,
      gender: 0
    });
    axios.get(Common.baseApiUrl + "getprescribers/" + Common.currentUser.id).then(function (response) {
      setPrescribers([{
        value: 0,
        label: "Non defini"
      }]);
      if (response.data.status == 200) {
        response.data.prescribers.forEach(function (p) {
          setPrescribers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.name + "(" + p.mobile + ")"
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setDataChangedPr(false);
    });
  }, [dataChangedPr]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "business_provider_id",
            label: "Provenance",
            rules: [{
              required: true,
              message: 'Choisir la catégorie'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: bpOptions,
              dropdownRender: function dropdownRender(menu) {
                return /*#__PURE__*/_jsxs(_Fragment, {
                  children: [menu, /*#__PURE__*/_jsx(Divider, {
                    style: {
                      margin: '8px 0'
                    }
                  }), /*#__PURE__*/_jsx(Space, {
                    style: {
                      padding: '0 8px 4px'
                    },
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "text",
                      icon: /*#__PURE__*/_jsx(Plus, {
                        size: 22
                      }),
                      onClick: function onClick() {
                        setShowAddBusinessProvider(true);
                      },
                      children: "AJOUTER"
                    })
                  })]
                });
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "prescriber_id",
            label: "Prescripteur",
            rules: [{
              required: true,
              message: 'Choisir la catégorie'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              showSearch: true,
              defaultActiveFirstOption: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: prescribers,
              dropdownRender: function dropdownRender(menu) {
                return /*#__PURE__*/_jsxs(_Fragment, {
                  children: [menu, /*#__PURE__*/_jsx(Divider, {
                    style: {
                      margin: '8px 0'
                    }
                  }), /*#__PURE__*/_jsx(Space, {
                    style: {
                      padding: '0 8px 4px'
                    },
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "text",
                      icon: /*#__PURE__*/_jsx(Plus, {
                        size: 22
                      }),
                      onClick: function onClick() {
                        setShowAddPrescriber(true);
                      },
                      children: "AJOUTER"
                    })
                  })]
                });
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "department_id",
            label: "Motif",
            rules: [{
              required: true,
              message: 'Choisir le motif'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onDeptChanged,
              defaultActiveFirstOption: true,
              disabled: deptDisabled,
              showSearch: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: deptOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "item_id",
            label: "Actes / examens",
            rules: [{
              required: true,
              message: 'Choisir le motif'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              mode: "multiple",
              defaultActiveFirstOption: true,
              disabled: serviceDisabled,
              showSearch: true,
              optionLabelProp: "label",
              optionFilterProp: "label",
              filterOption: function filterOption(input, option) {
                return option.label.toLowerCase().includes(input.toLowerCase());
              },
              options: serviceOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "company_id",
            label: "Prise en charge",
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onCompanyChanged,
              defaultValue: patient.company != null ? patient.company.id : null,
              showSearch: true,
              options: companyOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "insnumber",
            label: "Num prise en charge/Matricule",
            children: /*#__PURE__*/_jsx(Input, {
              disabled: insDisabled
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 4,
          sm: 12,
          xs: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "discount",
            label: "Remise",
            rules: [{
              required: true,
              message: "Champ obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: discounts
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          md: 3,
          sm: 4,
          xs: 3,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "PDA",
            children: /*#__PURE__*/_jsx(Switch, {
              onChange: handlePdaChange,
              disabled: pdaFieldDisabled,
              size: "default",
              checked: isPdaActive == 1,
              checkedChildren: /*#__PURE__*/_jsx(CheckCircleFill, {}),
              unCheckedChildren: /*#__PURE__*/_jsx(XCircleFill, {})
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: " ",
            name: "paid_amount",
            children: /*#__PURE__*/_jsx(InputNumber, {
              prefix: /*#__PURE__*/_jsx(CashStack, {}),
              placeholder: "Montant acompte",
              disabled: !isPdaActive,
              block: true,
              style: {
                width: "160px"
              }
            })
          })
        })]
      }), contextHolder, /*#__PURE__*/_jsx(Form.Item, {
        name: "submit",
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          disabled: deptOptions.length == 0,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "Facturer"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddPrescriber,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UN PRESCRIPTEUR"
      }),
      onClose: function onClose() {
        setShowAddPrescriber(false);
      },
      width: "290px",
      children: /*#__PURE__*/_jsx(AddPrescriber, {
        handler: function handler() {
          setDataChangedPr(true);
          setShowAddPrescriber(false);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddBusinessProvider,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UN AMBULANCIER"
      }),
      onClose: function onClose() {
        setShowAddBusinessProvider(false);
      },
      width: "290px",
      children: /*#__PURE__*/_jsx(AddBusinessProvider, {
        handler: function handler() {
          setDataChangedBp(true);
          setShowAddBusinessProvider(false);
        }
      })
    }), patient && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          size: 30
        }), " RECU"]
      }),
      width: "280px",
      open: showReceipt,
      onClose: function onClose() {
        setShowReceipt(false);
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsx("div", {
        ref: ref,
        style: {
          textAlign: 'center'
        },
        children: /*#__PURE__*/_jsx(OrderReceipt, {
          createdBill: createdBill,
          createdValues: patient,
          discount: discount,
          receipAmount: receipAmount,
          isPdaActive: isPdaActive,
          rdata: rdata,
          currentCompany: userCompany
        })
      })
    })]
  });
};
export default AddPatientItem;